export enum DocumentStatus {
  Pending = 'pending',
  Edited = 'edited',
  CandidateUnverified = 'candidateUnverified',
  EmployerUnverified = 'employerUnverified',
  NeitherVerified = 'neitherVerified',
  Verified = 'verified',
  Unverified = 'unverified',
  Unreadable = 'unreadable',
  YearOutOfRange = 'yearOutOfRange',
}

// Per-status render params.
//   - `verified: false` — blocks Submit (legacy Submit-gating signal).
//   - `deleteable` — toggles the trash icon on the legacy variant.
//   - `fixable` — routes the row variant in the OCR transient flow.
//     `true` → editable / inline-verified (recoverable);
//     `false` → inline-error (trash-only, non-recoverable).
//   - `icon: null` on partial-verify is intentional; the dropdowns /
//     warning copy communicate the state on the legacy variant.
export const DocumentStatusParams = {
  [DocumentStatus.Pending]: {
    icon: 'Document',
    verified: true,
    deleteable: true,
    fixable: true,
    sortOrder: 1,
    label: null,
  },
  [DocumentStatus.Edited]: {
    icon: 'CheckmarkFilled',
    verified: true,
    deleteable: true,
    fixable: true,
    sortOrder: 2,
    label: 'verified',
  },
  [DocumentStatus.CandidateUnverified]: {
    icon: null,
    verified: false,
    deleteable: true,
    fixable: false,
    sortOrder: 4,
    label: 'partiallyVerified',
  },
  [DocumentStatus.EmployerUnverified]: {
    icon: null,
    verified: false,
    deleteable: true,
    fixable: false,
    sortOrder: 4,
    label: 'partiallyVerified',
  },
  [DocumentStatus.NeitherVerified]: {
    icon: null,
    verified: false,
    deleteable: true,
    fixable: false,
    sortOrder: 4,
    label: 'partiallyVerified',
  },
  [DocumentStatus.Verified]: {
    icon: 'CheckmarkFilled',
    verified: true,
    deleteable: true,
    fixable: true,
    sortOrder: 3,
    label: 'verified',
  },
  [DocumentStatus.Unverified]: {
    icon: 'ErrorFilled',
    verified: false,
    deleteable: true,
    fixable: false,
    sortOrder: 1,
    label: 'needsAttention',
  },
  // `Unreadable` (OCR returned `succeeded` with zero extracted fields,
  // e.g. cat photos) shares the file-type-not-accepted row with
  // `Unverified` — both are non-recoverable, re-running OCR on the same
  // file can't change the verdict.
  [DocumentStatus.Unreadable]: {
    icon: 'ErrorFilled',
    verified: false,
    deleteable: true,
    fixable: false,
    sortOrder: 1,
    label: 'needsAttention',
  },
  // `YearOutOfRange` (EVERI-3428): Extend confidently identified a recognized,
  // required doc type but the extracted year matches no open required slot.
  // Locked as supporting documentation — delete-only InlineError, persisted as
  // a non-required `multi_documents` doc that never satisfies a required slot.
  [DocumentStatus.YearOutOfRange]: {
    icon: 'WarningAltFilled',
    verified: false,
    deleteable: true,
    fixable: false,
    sortOrder: 4,
    label: 'partiallyVerified',
  },
};
